<template>
  <div class="page">
    <el-card class="card">
      <div class="title">登录</div>
      <el-form :model="form" label-width="80px" @submit.native.prevent>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入密码">
            <template #suffix>
              <span class="password-toggle" @click="showPassword = !showPassword">
                {{ showPassword ? '👁' : '👁‍🗨' }}
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <div class="row">
            <el-input v-model="form.captcha_code" placeholder="请输入右侧字符" />
            <div class="captcha" @click="loadCaptcha">
              <img v-if="captcha_image" :src="captcha_image" alt="captcha" />
              <span v-else>加载中...</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width: 100%" @click="doLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>

      <div class="footer">
        没有账号？
        <el-link type="primary" @click="$router.push('/register')">去注册</el-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from "../api";
import { encryptPassword } from "../utils/crypto";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      showPassword: false,
      captcha_id: "",
      captcha_image: "",
      form: {
        phone: "",
        password: "",
        captcha_id: "",
        captcha_code: ""
      }
    };
  },
  created() {
    this.loadCaptcha();
  },
  methods: {
    async loadCaptcha() {
      try {
        const { data } = await api.get("/api/auth/captcha");
        this.captcha_id = data.captcha_id;
        this.captcha_image = data.image_base64;
        this.form.captcha_id = data.captcha_id;
        this.form.captcha_code = "";
      } catch (e) {
        this.$message.error("验证码加载失败");
      }
    },
    async doLogin() {
      this.loading = true;
      try {
        const encryptedPassword = await encryptPassword(this.form.password);
        const { data } = await api.post("/api/auth/login", {
          ...this.form,
          password: encryptedPassword
        });
        localStorage.setItem("access_token", data.access_token);
        this.$router.replace("/");
      } catch (e) {
        console.log(e);
        debugger
        this.$message.error(e?.userMessage || "登录失败");
        this.loadCaptcha();
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: -webkit-radial-gradient(circle, #fff, #cde6ff);
}
.card {
  width: 420px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}
.row {
  display: flex;
  gap: 10px;
}
.captcha {
  width: 110px;
  height: 39px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.captcha img {
  width: 100%;
  height: 100%;
}
.hint {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}
.footer {
  text-align: center;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

